import React from "react";
import Context from "../../../../context";

import { CustomModal } from "../../../../components";

import "./index.sass";
import UpdateComponent from "./Components";

const Update = ({ role }: { role: "ADMIN" | "SUPER_AGENT_SCHOOL" }) => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal } = React.useContext(Context.CompanyScreen);

  function UpdateComponentByRole() {
    switch (role) {
      case "ADMIN":
        return <UpdateComponent.Administrator />;
      case "SUPER_AGENT_SCHOOL":
        return <UpdateComponent.SuperAgent />;
      default:
        return <></>;
    }
  }
  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="company-update-modal-container">
      <CustomModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "UPDATE"}
        maxHeight={"80vh"}
        overlayOpacity={"scroll"}
      >
        <UpdateComponentByRole />
      </CustomModal>
    </section>
  );
};

export default Update;
